export function getTag() {
  const hostname = window.location.hostname;

  let tag: string | undefined = undefined;

  if (hostname.endsWith('localhost')) {
    const parts = hostname.split('.');
    if (parts.length === 2) {
      const subdomain = parts[0];
      if (subdomain && subdomain !== 'app') {
        tag = subdomain;
      }
    }
    return tag;
  }
  if (hostname.endsWith('join4green.com')) {
    const parts = hostname.split('.');
    if (parts.length === 3 || parts.length === 4) {
      const subdomain = parts[0];
      if (subdomain && subdomain !== 'app') {
        tag = subdomain;
      }
    }
  }
  return tag;
}
